<template>
  <el-pagination
      class="pagination-wrapper"
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="rForm.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="rForm.size"
      background
      layout="total, prev, pager, next,sizes, jumper"
      :total="rForm.total"
      style="float: right;margin-right: 30px"
  >
  </el-pagination>
</template>

<script>
export default {
  name: "pageFooter",
  props: {
    rForm: {},
  },
  data() {
    return {}
  },
  methods: {
    // 切换分页
    currentChange(val) {
      this.$emit("current-change", val);
    },
    // 显示最大条数变动
    sizeChange(val) {
      this.$emit("size-change", val);
    },
  }
}
</script>

<style scoped>
 /* .pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100vw;
    height: 8vh;
    background: #FFFFFF;
    padding-right: 2rem;
    box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
    border-radius: 2px;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index:10;
    box-sizing: border-box;
    z-index: 10;
  }*/
</style>
